import React from "react"
import Button from "../Button/Button"
interface AssignmentPageItemApproveRejectFooterProps {
	approveLabel: string
	rejectLabel: string
	escalateLabel?: string
	onApprove: () => void
	onReject: () => void
	onEscalate?: () => void
	approveTooltip?: string
	rejectTooltip?: string
	escalateTooltip?: string
}

export function AssignmentPageItemApproveRejectFooter({
	approveLabel,
	rejectLabel,
	escalateLabel,
	onApprove,
	onReject,
	onEscalate,
	approveTooltip,
	rejectTooltip,
	escalateTooltip,
}: AssignmentPageItemApproveRejectFooterProps) {
	return (
		<div className="assignment-page-item-callback-review-footer">
			<div className="assignment-page-item-callback-review-footer-buttons">
				{escalateLabel && onEscalate && (
					<Button
						prefixIcon="user-geometric-action-cross-remove"
						theme="neutral"
						variant="subtle"
						size="normal"
						onClick={onEscalate}
						tooltip={escalateTooltip}
						className="assignment-page-item-callback-review-footer-button"
					>
						{escalateLabel}
					</Button>
				)}
				<Button
					prefixIcon="delete-close-x"
					theme="danger"
					size="normal"
					onClick={onReject}
					tooltip={rejectTooltip}
					className="assignment-page-item-callback-review-footer-button"
				>
					{rejectLabel}
				</Button>
				<Button
					prefixIcon="approve-v-check-validation"
					theme="success"
					size="normal"
					onClick={onApprove}
					tooltip={approveTooltip}
					className="assignment-page-item-callback-review-footer-button"
				>
					{approveLabel}
				</Button>
			</div>
		</div>
	)
}
